import React, { useEffect } from 'react';
import { notification, Button } from 'antd';
import { SyncOutlined, HomeOutlined } from '@ant-design/icons';
// Change useNavigate to useHistory
import { useLocation, useHistory } from 'react-router-dom';

const OrgSyncListener = () => {
    const [api, contextHolder] = notification.useNotification();
    const location = useLocation();
    const history = useHistory(); // Use history for v5

    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === 'targetOrg' && e.newValue !== e.oldValue) {
                showSyncPrompt();
            }
        };

        const showSyncPrompt = () => {
            const isItemsDetailPage = location.pathname.startsWith('/items/');
            const isOrderDetailPage = location.pathname.startsWith('/order/');
            const goHome = (isItemsDetailPage || isOrderDetailPage);
            const key = `sync-notification`;

            api.warning({
                message: '提携先事業所が変更されました',
                description: goHome
                    ? '別のタブで所属事業所、相手先事業所が切り替えられました。「詳細画面」では所属事業所、相手先事業所を切り替えることはできません。Home画面に戻って選択し直してください。'
                    : '別のタブで所属事業所または相手先事業所が変更されました。最新の表示にするには、ページを更新してください。',
                placement: 'top',
                duration: 0,
                key,
                btn: (
                    <Button
                        type="primary"
                        icon={goHome ? <HomeOutlined /> : <SyncOutlined />}
                        onClick={() => {
                            if (goHome) {
                                // history.push replaces navigate
                                // history.push('/');
                                window.location.href = '/'
                                // api.destroy(key);
                            } else {
                                window.location.reload();
                            }
                        }}
                    >
                        {goHome ? 'ホーム画面に戻る' : '今すぐ画面を更新'}
                    </Button>
                ),
            });
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, [api, location.pathname, history]);

    return <>{contextHolder}</>;
};

export default OrgSyncListener;
